import React from 'react'
import './InputTextArea.css'

const InputTextArea = ({
    setValue = () => { },
    onSend = () => { },
    placeholder,
    name = '',
    type = '',
    value,
}) => {

    const auto_height = (e) => {
        e.target.style.height = "1px";
        e.target.style.height = (e.target.scrollHeight) + "px";
    }

    return (
        <textarea
            onKeyPress={e => {
                if (e.key === 'Enter' && !e.shiftKey) {
                    e.preventDefault()
                    onSend()
                }
            }}
            className={`input-textarea-content ${type}`}
            rows="1"
            value={value}
            onChange={e => setValue(e.target.value)}
            onInput={e => auto_height(e)}
            name={name}
            type="text"
            placeholder={placeholder} />
    )
}

export default InputTextArea
